import { QueryParamsModel } from '../../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, tap, delay } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../../_base/crud';
// Services
import { VehicleService } from '../_services/vehicle.service';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';
// State
import { AppState } from '../../../../core/reducers';
// Actions
import {
    VehicleActionTypes,
    VehiclePageRequested,
    VehiclePageLoaded,
    OneVehicleDeleted,
    VehicleActionToggleLoading,
    VehiclePageToggleLoading,
    VehicleUpdated,
    VehicleCreated,
    VehicleOnServerCreated
} from '../_actions/vehicle.actions';
import { of } from 'rxjs';

@Injectable()
export class VehicleEffects {
    showPageLoadingDistpatcher = new VehiclePageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new VehicleActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new VehicleActionToggleLoading({ isLoading: false });

    @Effect()
    loadVehiclePage$ = this.actions$.pipe(
        ofType<VehiclePageRequested>(VehicleActionTypes.VehiclePageRequested),
        mergeMap(({ payload }) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.vehicleService.findVehicles(payload.page);
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];

            this.sharedService.updateVehicleList(result.items);
            //console.log(result.items);
            const pageLoadedDispatch = new VehiclePageLoaded({
                vehicles: result.items,
                totalCount: result.totalCount,
                page: lastQuery
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteVehicle$ = this.actions$
        .pipe(
            ofType<OneVehicleDeleted>(VehicleActionTypes.OneVehicleDeleted),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.vehicleService.deleteVehicle(payload.VehicleMId);
            }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateVehicle$ = this.actions$
        .pipe(
            ofType<VehicleUpdated>(VehicleActionTypes.VehicleUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.vehicleService.updateVehicle(payload.vehicle.VehicleMId, payload.vehicle);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    createVehicle$ = this.actions$
        .pipe(
            ofType<VehicleOnServerCreated>(VehicleActionTypes.VehicleOnServerCreated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.vehicleService.createVehicle(payload.vehicle).pipe(
                    tap(res => {
                        //console.log(res);
                        //const resValue = Object.keys(res).map(key => res[key]);
                        //console.log(resValue[0].value);
                        //this.store.dispatch(new VehicleCreated({ vehicle: res }));
                        if (res.VehicleMId == 0) {
                            this.store.dispatch(new VehicleCreated({ vehicle: res }));
                        } else {
                            console.log('There is somthing wrong');
                            //this.store.dispatch(new VehicleErrorMessage({ _errorMessage: resValue[0].value }));
                        }

                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    constructor(private actions$: Actions, private vehicleService: VehicleService,
        private sharedService: ShareddataserviceService, private store: Store<AppState>) { }
}
